'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const breakpoints = require('../../../style/breakpoints.js');

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var STRING = 'string';
var BOOLEAN = 'boolean';
var NUMBER = 'number';
var DIMENSIONREGEX = /[height|width]$/;
var LETTERREGEX = /[A-Z]/g;
var camelToHyphen = function camelToHyphen(str) {
  return str.replace(LETTERREGEX, function (m) {
    return "-".concat(m.toLowerCase());
  }).toLowerCase();
};
var objectToString = function objectToString(query, isStrictMedia) {
  return Object.keys(query).map(function (feature) {
    var value = query[feature];
    var valueType = _typeof(value);
    feature = camelToHyphen(feature);
    // if value is a string and exists in our breakpoints obj then populate
    // the variable with its px value
    if (valueType === STRING && breakpoints[value]) {
      var breakPointValue = breakpoints[value];
      var isMax = feature.includes('max-width');
      value = isStrictMedia && isMax ? "".concat(parseInt(breakPointValue) - 1, "px") : breakPointValue;
    }
    if (valueType === BOOLEAN) {
      return value ? feature : "not ".concat(feature);
    }
    if (valueType === NUMBER && DIMENSIONREGEX.test(feature)) {
      value = "".concat(value, "px");
    }
    return "(".concat(feature, ": ").concat(value, ")");
  }).join(' and ');
};
var createUseMedia = function createUseMedia(effect) {
  return function (rawQuery, defaultState) {
    var _useState = React.useState(defaultState),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];
    var isStrictMedia = rawQuery.hasOwnProperty("maxWidth") && rawQuery.hasOwnProperty("minWidth");
    var query = objectToString(rawQuery, isStrictMedia);
    effect(function () {
      if (typeof window !== 'undefined') {
        var mounted = true;
        var mql = window && window.matchMedia && window.matchMedia(query);
        if (mql) {
          var onChange = function onChange() {
            if (!mounted) return;
            setState(!!mql.matches);
          };
          mql.addListener(onChange);
          setState(mql.matches);
          return function () {
            mounted = false;
            mql.removeListener(onChange);
          };
        } else {
          return;
        }
      } else {
        return;
      }
    }, [query]);
    if (typeof state === 'undefined' && typeof window !== 'undefined' && window.matchMedia) {
      var mql = window.matchMedia(query);
      if (mql) {
        setState(mql.matches);
      }
    }
    return !!state;
  };
};
var useMedia = createUseMedia(React.useEffect);

exports.default = useMedia;
exports.useMedia = useMedia;
